/**
 * Catálogo de fontes premium selecionáveis pro título do Hero da página
 * pública de venda (RyanProductPage) — configurado por produto no admin de
 * marketing (Section "Hero"). Carregadas via Google Fonts em public/index.html
 * (mesmo `<link>` que já carrega Inter/Syne/JetBrains Mono), exceto a opção
 * "Clássica" (default), que usa uma pilha de fontes de sistema sem carregar
 * nada — mantém o visual atual pra produtos que nunca configuraram isso.
 */

export interface RyanHeroFont {
  id: string;
  label: string;
  family: string;
}

export const RYAN_HERO_FONTS: RyanHeroFont[] = [
  { id: 'serif-classic', label: 'Clássica', family: "'Georgia', 'Garamond', 'Times New Roman', serif" },
  { id: 'playfair', label: 'Editorial', family: "'Playfair Display', serif" },
  { id: 'cormorant', label: 'Elegante', family: "'Cormorant Garamond', serif" },
  { id: 'fraunces', label: 'Contemporânea', family: "'Fraunces', serif" },
  { id: 'libre-baskerville', label: 'Literária', family: "'Libre Baskerville', serif" },
  { id: 'dm-serif', label: 'Minimalista', family: "'DM Serif Display', serif" },
];

const DEFAULT_HERO_FONT = RYAN_HERO_FONTS[0].family;

export function getRyanHeroFontFamily(fontId?: string): string {
  return RYAN_HERO_FONTS.find(f => f.id === fontId)?.family || DEFAULT_HERO_FONT;
}
